export default {
  background: {
    type: "color",
    color: "#F5F3FF",
    topGradient: "#F5F3FF",
    bottomGradient: "#F5F3FF",
    image: null,
  },
  color: { primary: "#181052", secondary: "#FFF" },
  elements: { shape: "Rounded", style: "Solid" },
  font: "Poppins",
};

